import { AppConfigModel } from "../abstract/app-config.model";

export class NumericComparator extends AppConfigModel {

    static override CLASS_NAME: string = 'NumericComparator';
}
